import cn from 'classnames';
import { FC, useRef } from 'react';
import { MdDeleteForever } from 'react-icons/md';
import logo from '../../../assets/images/food-mock.png';
import { IconButton } from '../../icon-button/icon-button';
import { Loader } from '../../loader/loader';
import { InputFile, InputFileProps } from '../input-file';
import s from './input-file-square.module.css';

export interface InputFileSquareProps extends InputFileProps {
  isLoading?: boolean;
  onChange: (files?: File[]) => void;
  deletable?: boolean;
}

export const InputFileSquare: FC<InputFileSquareProps> = (props) => {
  const { src = logo, isLoading, onChange, className, deletable, ...other } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    onChange();
  };
  return (
    <InputFile
      ref={inputRef}
      disabled={isLoading}
      wrapperClassName={className}
      onChange={(e) => onChange(e)}
      {...other}
    >
      <img src={src} alt="img" className={cn(s.img, className)} />
      {deletable && (
        <IconButton className={s.delete} onClick={handleDelete} variant="danger" size="sm">
          <MdDeleteForever />
        </IconButton>
      )}
      {isLoading && <Loader size="sm" />}
    </InputFile>
  );
};
